import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTheme } from '@emotion/react';
import { Surface, useSurfaceColor } from '..';
const Switch = (props) => {
    const theme = useTheme();
    return (_jsxs(Surface, { as: "label", elevation: x => x + 3, css: [
            {
                display: 'inline-flex',
                width: '3.3rem',
                borderRadius: 'calc(1.8rem / 2)',
                padding: '0.2rem',
                cursor: 'pointer',
                ':has(input:checked)': {
                    '> div': {
                        backgroundColor: theme.color.primary,
                        transform: 'translateX(100%)',
                    },
                },
            },
        ], children: [_jsx("input", { ...props, type: "checkbox", css: { display: 'none' } }), _jsx("div", { css: {
                    width: '1.5rem',
                    height: '1.5rem',
                    borderRadius: 'calc(1.5rem / 2)',
                    backgroundColor: useSurfaceColor(),
                    transition: 'linear 0.125s',
                } })] }));
};
export default Switch;
//# sourceMappingURL=Switch.js.map